import axios from "axios";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Spinner from "../../Components/Spinner/Spinner";
import baseUrl from "../../baseUrl";

const AllBlogs = () => {
  const navigate = useNavigate();

  const [blogs, setBlogs] = useState([]);
  const token = JSON.parse(localStorage.getItem("admin-token"));

  const handleDelete = (_id) => {
    axios
      .post(
        `${baseUrl}/admin/delete-blog/${_id}`,
        {
          _id,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then((res) => {
        setBlogs(blogs.filter((item) => item._id !== _id));
        navigate("/admin/all-blogs");
        toast.success(res.data.message);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    axios
      .get(`${baseUrl}/admin/all-blogs`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        setBlogs(res.data.blogs);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [token]);
  return (
    <>
      <nav
        className="container  w-auto flex text-black font-bold mx-5 my-4"
        aria-label="Breadcrumb"
      >
        <h3 className="text-gray-700 text-3xl font-medium">All blogs</h3>
        <Link
          to="/admin/add-blog"
          className=" text-sm font-medium bg-green-700 text-gray-300 hover:bg-green-800 hover:text-white  px-3 py-2 rounded-md   ml-5 hover:cursor-pointer"
        >
          <i className="fa-solid fa-plus "></i>Add Blog
        </Link>
      </nav>

      <div className="container w-auto mx-auto px-6 py-3">
        <div className="flex flex-col">
          <div className="-my-2 py-2 overflow-x-auto sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8">
            <div className="align-middle inline-block min-w-full shadow overflow-hidden sm:rounded-lg border-b border-gray-200">
              {blogs.length <= 0 ? (
                <h1 className="text-center text-3xl">
                  <Spinner />
                  No blogs
                </h1>
              ) : (
                <table className="min-w-full">
                  <thead>
                    <tr>
                      <th className="px-6 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">
                        Name
                      </th>

                      <th className="px-6 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">
                        Action
                      </th>
                    </tr>
                  </thead>

                  <tbody className="bg-white">
                    {/* loop */}
                    {blogs.map((blog) => (
                      <tr key={blog._id}>
                        <td className="px-6 py-4 whitespace-no-wrap border-b border-gray-200">
                          <Link to={`/admin/single-blog/${blog._id}`}>
                            <div className="flex items-center">
                              <div className="flex-shrink-0 h-10 w-10">
                                <img
                                  className="h-10 w-10 rounded-full"
                                  src={blog.image.url}
                                  alt="iproduct image"
                                />
                              </div>
                              <div className="ml-4">
                                <div className="text-sm leading-5 font-medium text-gray-900">
                                  {blog.title}
                                </div>
                              </div>
                            </div>
                          </Link>
                        </td>

                        <td className="px-6 py-4 whitespace-no-wrap border-b border-gray-200 text-sm leading-5 font-medium">
                          <Link
                            to={`/admin/update-blog/${blog._id}`}
                            className="text-indigo-600 hover:text-indigo-900 mr-3"
                          >
                            <i className="fas fa-edit"></i>
                          </Link>
                          <button
                            onClick={() => handleDelete(blog._id)}
                            type="submit"
                            className="text-red-600 hover:text-red-900"
                          >
                            <i className="fas fa-trash-alt"></i>
                          </button>
                        </td>
                      </tr>
                    ))}
                    {/* loop  */}
                  </tbody>
                </table>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AllBlogs;
